import React from 'react'

export default class Multipart extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            values: Array.isArray(this.props.values) ? this.props.values : [],
            editValue: '',
            isEdit: false,
            suggestions: ['jedan', 'dva', 'tri'],
        }
    }

    componentWillReceiveProps (nextProps) {
        if ( (nextProps.values !== this.props.values)) {
            this.props = nextProps
            this.setState({
                values: this.props.values
            });
        }
    }

    startEditing = (id=null) => {
        if (this.props.disabled===true) {
            return
        }

        if (id===null) {
            this.setState({
                editValue: '',
                isEdit: true,
            }, ()=>{
                this.input.focus()
            })
        } else {
            let nv = []
            for (let i=0; i<this.state.values.length; i++) {
                if (i!==id) { nv.push(this.state.values[i]) }
            }
            this.setState({
                values: nv,
                editValue: this.state.values[id],
                isEdit: true
            }, ()=>{
                this.input.focus()
            })
        }

    }

    finishEditing = (forceNextStart=false) => {
        // already has same value?
        if (this.state.values.indexOf(this.state.editValue)!==-1) {
            this.setState({
                editValue: ''
            })
            return
        }

        // empty
        if (this.state.editValue==='') {
            this.setState({
                editValue: '',
                isEdit: false,
            }, ()=>{
                if (forceNextStart) {
                    this.startEditing()
                }
            })
            return
        }

        this.setState({
            values: [...this.state.values, this.state.editValue],
            isEdit: false,
        }, ()=>{
            if (this.props.onChange) {
                this.props.onChange(this.state.values)
            }
        })
    }

    removeAt = (id) => {
        this.state.values.splice(id, 1)
        this.setState({
            values: this.state.values,
            isEdit: false
        }, ()=>{
            if (this.props.onChange) {
                this.props.onChange([...this.state.values], false)
            }
        })
    }

    render() {
        return (
            <span
                className="multipart"
                tabIndex={(this.state.isEdit)?"-1":"0"}
                onFocus={()=>{
                    if(!this.state.isEdt) {
                        this.startEditing()
                    }
                }}
                // onClick={()=>{
                //     this.startEditing()
                // }}
            >
                {
                    this.state.values.map(
                        (value, id) => (
                                <span
                                    key={value}
                                    onClick={e=>{e.stopPropagation(); this.startEditing(id) }}
                                >
                                    {value}
                                    {
                                        (this.props.disabled!==true)
                                            ? <span onClick={e=>{e.stopPropagation(); this.removeAt(id)}} className="remove">x</span>
                                            : null
                                    }
                                </span>
                        )
                    )
                }
                {
                    (this.state.isEdit)
                        ?   <input
                                ref={c=>this.input=c}
                                type="text"
                                spellCheck="false"
                                placeholder="Add new..."
                                value={this.state.editValue}
                                onChange={e=>{ this.setState({editValue: e.target.value}), ()=>{
                                    // this.input.style.width = this.input.scrollWidth + 'px'
                                } }}
                                onClick={e=>{e.stopPropagation();  }}
                                onBlur={()=>{
                                    this.finishEditing()
                                }}
                                onKeyDown={e=>{
                                    // 'Enter' or 'semicolon'
                                    if (e.keyCode===13 || e.keyCode===186) {
                                        this.finishEditing(true)
                                    }
                                    // 'Backspace'
                                    if (e.keyCode===8 && this.state.editValue==='') {
                                        e.stopPropagation()
                                        this.startEditing(this.state.values.length-1)
                                    }
                                }}
                            />
                        : null
                }
            </span>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Multipart.js